enum TipoEnvio {
    Automatico = 1,
    Manual = 2,
}

export default TipoEnvio;
